// @ts-nocheck

import Base from '../../../ts/_base';
import Multi from '../../../ts/_multi-inherit';
import QuickSeachEureka from 'ui-theme/widgets/quick-search/js/_quick-search.js';

export default class QuickSearch extends Multi(QuickSeachEureka, Base) {
    constructor() {
        super();
        this.URLParameters = {
            hs: 'historyItemsConf',
            pts: 'publicationTitlesConf',
            ptgs: 'groupTitlesConf',
            ptfs: 'publicationItemsConf',
            ts: 'topicsConf',
            cs: 'contributorsConf',
            pt: 'publicationTypesConf'
        };
    }
    get childSelectors(): {[key: string]: string} {
        return {
            submitBtn: '.quick-search--header .quick-search__btn',
            activeQuickSearchForm: '.quick-search--header [role="tabpanel"].show form',
            qsForms: '[name="defaultQuickSearch"],[name="thisJournalQuickSearch"],[name="citationQuickSearch"]',
            citationSubmit: 'citationFormSubmit'
        }
    }


    setElements() {
        super.setElements()
        this._elements.qsForms = document.querySelectorAll(this.childSelectors.qsForms);
        this._elements.citationSubmit = document.getElementById(this.childSelectors.citationSubmit);
    }
    onFormSubmit(form, e) { }
    protected controlSubmit(): void {
        const submitBtn = this.queryElm(this.childSelectors.submitBtn) as HTMLButtonElement;
        submitBtn.addEventListener('click', this.handleMutliSubmit.bind(this));
    }

    protected addEventListeners() {
        super.addEventListeners(); 
        this._elements.qsForms.forEach(form => {
            form.addEventListener('submit', this.onFormSubmit.bind(this, form));
        });
        this.controlSubmit();
    }

    protected handleMutliSubmit(e: MouseEvent): void {
        e.preventDefault();
        const activeForm = this.queryElm(this.childSelectors.activeQuickSearchForm) as HTMLFormElement;
        if(!activeForm) return;
        if(!activeForm.checkValidity()) {
            if(activeForm.name == "citationQuickSearch") {
                this._elements.citationSubmit.click();
            }
        } else {
            activeForm.submit();
        }
    }
    protected buildFetchURL(input) {
        const parameters = Object.entries(this.URLParameters).reduce((acc, [key, prop]) => {
            const value = input.dataset[prop];
            if (value) {
                acc.push(`${key}=${value}`);
            }
            return acc;
        }, []);
        const term = input.value.trim().replace(/\s\s+/g, ' ');
        if (
            term.split(' ').length >= input.dataset.autoCompleteMaxWords ||
            term.length >= input.dataset.autoCompleteMaxChars
        ) {
            return '';
        }
        return `/action/doSuggest?target=auto-complete&query=${encodeURIComponent(term)}&${parameters.join(
            '&'
        )}&fl=PubID${input.searchType === 'journal' ? '&within=' + input.seriesKey : ''}`;
    }
}


